import { apiRequest } from './http'
import type { ItemList } from '@/types/api'

export interface ProductDto {
  id: number | string
  productCode: string
  name: string
  unit: string
  quantityScale: number | string
  salePrice: number | string
  costPrice: number | string
  status: 'active' | 'inactive'
  used?: boolean
}

export interface StoreDto {
  id: number | string
  storeCode: string
  name: string
  address: string
  phone: string
  status: 'active' | 'inactive'
  used?: boolean
}

export interface EmployeeDto {
  id: number | string
  employeeNo: string
  name: string
  phone: string
  loginAccount: string
  hasLoginPassword?: boolean
  department: string
  joinDate: string
  status: 'active' | 'inactive'
  stores?: Array<{ id: number | string; name: string }>
}

export const masterDataApi = {
  products: () => apiRequest<ItemList<ProductDto>>('/master-data/products'),
  saveProduct: (id: number | undefined, body: unknown) => apiRequest(`/master-data/products${id ? `/${id}` : ''}`, {
    method: id ? 'PUT' : 'POST', body
  }),
  deleteProduct: (id: number) => apiRequest(`/master-data/products/${id}`, { method: 'DELETE' }),
  stores: () => apiRequest<ItemList<StoreDto>>('/master-data/stores'),
  saveStore: (id: number | undefined, body: unknown) => apiRequest(`/master-data/stores${id ? `/${id}` : ''}`, {
    method: id ? 'PUT' : 'POST', body
  }),
  deleteStore: (id: number) => apiRequest(`/master-data/stores/${id}`, { method: 'DELETE' }),
  employees: () => apiRequest<ItemList<EmployeeDto>>('/master-data/employees'),
  saveEmployee: (id: number | undefined, body: unknown) => apiRequest(`/master-data/employees${id ? `/${id}` : ''}`, {
    method: id ? 'PUT' : 'POST', body
  }),
  deleteEmployee: (id: number) => apiRequest(`/master-data/employees/${id}`, { method: 'DELETE' }),
  attendance: (id: number, month: string) => apiRequest<ItemList<Record<string, unknown>>>(`/master-data/employees/${id}/attendance`, {
    query: { month }
  })
}
